import { render, staticRenderFns } from "./base.vue?vue&type=template&id=349b9158&lang=pug&"
import script from "./base.vue?vue&type=script&lang=js&"
export * from "./base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('349b9158')) {
      api.createRecord('349b9158', component.options)
    } else {
      api.reload('349b9158', component.options)
    }
    module.hot.accept("./base.vue?vue&type=template&id=349b9158&lang=pug&", function () {
      api.rerender('349b9158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/base.vue"
export default component.exports